import {
    Button,
    CalendarIcon,
    Image,
    InfoIcon,
    PersonIcon,
    Tooltip,
} from "@fluentui/react-northstar";
import { BASE_URL_ILLUSTRATIONS } from "../../../constants";
import { ROUTES } from "../../../constants/routes";

export const NAV_LIST_OFFBOARDING = [
    {
        id: 1,
        label: "Départ du collaborateur",
        pathname: ROUTES.offboarding.prepare_offboarding,
        image: (
            <Image
                src={`${BASE_URL_ILLUSTRATIONS}/New_Collab-Step1_infos.svg`}
                width="300px"
                styles={{
                    opacity: 0.5,
                }}
            />
        ),
        required: true,
    },
    {
        id: 2,
        label: "Motif et justificatifs",
        pathname: `${ROUTES.offboarding.prepare_offboarding}/justification`,
        image: (
            <Image
                src={`${BASE_URL_ILLUSTRATIONS}/New_Collab-Step1_infos.svg`}
                width="300px"
                styles={{
                    opacity: 0.5,
                }}
            />
        ),
        required: true,
    },
    {
        id: 3,
        label: "Solde de congés",
        pathname: `${ROUTES.offboarding.prepare_offboarding}/leave_balances`,
        image: (
            <Image
                src={`${BASE_URL_ILLUSTRATIONS}/New_Collab-Step4_role.svg`}
                width="300px"
                styles={{
                    opacity: 0.5,
                }}
            />
        ),
        required: true,
    },
    {
        id: 4,
        label: "Matériel et accès",
        pathname: `${ROUTES.offboarding.prepare_offboarding}/equipments_access`,
        image: (
            <Image
                src={`${BASE_URL_ILLUSTRATIONS}/New_Collab-Step2_stuff.svg`}
                width="300px"
                styles={{
                    opacity: 0.5,
                }}
            />
        ),
        required: false,
    },
    {
        id: 5,
        label: "Attribution de tâches",
        pathname: `${ROUTES.offboarding.prepare_offboarding}/attribute_tasks`,
        image: (
            <Image
                src={`${BASE_URL_ILLUSTRATIONS}/New_Collab-Step3_tasks.svg`}
                width="300px"
                styles={{
                    opacity: 0.5,
                }}
            />
        ),
        required: false,
    },
];

export const ITEM_PERIOD_NOTICE = [
    {
        id: 1,
        key: 1,
        header: "1 mois",
    },
    {
        id: 2,
        key: 2,
        header: "2 mois",
    },
    {
        id: 3,
        key: 3,
        header: "3 mois",
    },
    {
        id: 4,
        key: 4,
        header: "Personnalisée",
    },
    {
        id: 5,
        key: 5,
        header: "Aucun préavis",
    },
];

export const HEADER = {
    items: [
        <Button
            key="btn_1"
            styles={{ padding: "0" }}
            as="span"
            text
            content={"Nom de la Tâche"}
            size="small"
        />,
        <Button
            key="btn_2"
            styles={{ padding: "0" }}
            as="span"
            text
            icon={<CalendarIcon />}
            content={"Date d’échéance"}
            size="small"
        />,
        <>
            <Button
                styles={{ paddingLeft: "0" }}
                as="span"
                icon={<PersonIcon />}
                text
                content={"Responsable"}
                size="small"
            />
            <Tooltip
                content="Défini suivant la règle du modèle ou manuellement"
                pointing
                subtle={false}
                trigger={<InfoIcon outline />}
            />
        </>,
        "",
    ],
};
